/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 18.0002L18 18.0002M6 6.00024H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 14L18 14M11 10L18 10M6 10L8 12L6 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 18L18 18M11 14L18 14M11 10L18 10M6 6H18M6 10L8 12L6 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM6.00012 5.2501C5.58591 5.2501 5.25012 5.58589 5.25012 6.0001C5.25012 6.41431 5.58591 6.7501 6.00012 6.7501L18.0001 6.7501C18.4143 6.7501 18.7501 6.41431 18.7501 6.0001C18.7501 5.58589 18.4143 5.2501 18.0001 5.2501L6.00012 5.2501ZM5.46979 9.46976C5.1769 9.76266 5.1769 10.2375 5.46979 10.5304L6.93946 12.0001L5.46979 13.4698C5.1769 13.7627 5.1769 14.2375 5.46979 14.5304C5.76268 14.8233 6.23756 14.8233 6.53045 14.5304L8.53045 12.5304C8.82334 12.2375 8.82334 11.7627 8.53045 11.4698L6.53045 9.46976C6.23756 9.17687 5.76268 9.17687 5.46979 9.46976ZM11.0001 9.2501C10.5859 9.2501 10.2501 9.58588 10.2501 10.0001C10.2501 10.4143 10.5859 10.7501 11.0001 10.7501L18.0001 10.7501C18.4143 10.7501 18.7501 10.4143 18.7501 10.0001C18.7501 9.58588 18.4143 9.2501 18.0001 9.2501L11.0001 9.2501ZM11.0001 13.2501C10.5859 13.2501 10.2501 13.5859 10.2501 14.0001C10.2501 14.4143 10.5859 14.7501 11.0001 14.7501L18.0001 14.7501C18.4143 14.7501 18.7501 14.4143 18.7501 14.0001C18.7501 13.5859 18.4143 13.2501 18.0001 13.2501L11.0001 13.2501ZM6.00012 17.2501C5.58591 17.2501 5.25012 17.5859 5.25012 18.0001C5.25012 18.4143 5.58591 18.7501 6.00012 18.7501L18.0001 18.7501C18.4143 18.7501 18.7501 18.4143 18.7501 18.0001C18.7501 17.5859 18.4143 17.2501 18.0001 17.2501L6.00012 17.2501Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M6 18L18 18M11 14L18 14M11 10L18 10M6 6H18M6 10L8 12L6 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 18L18 18M11 14L18 14M11 10L18 10M6 6H18M6 10L8 12L6 14M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.25 6C5.25 5.58579 5.58579 5.25 6 5.25L18 5.25C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.41422 18.4142 6.75 18 6.75L6 6.75C5.58579 6.75 5.25 6.41422 5.25 6ZM5.46967 10.5303C5.17678 10.2374 5.17678 9.76256 5.46967 9.46967C5.76256 9.17677 6.23744 9.17677 6.53033 9.46967L8.53033 11.4697C8.82322 11.7626 8.82322 12.2374 8.53033 12.5303L6.53033 14.5303C6.23744 14.8232 5.76256 14.8232 5.46967 14.5303C5.17678 14.2374 5.17678 13.7626 5.46967 13.4697L6.93934 12L5.46967 10.5303ZM10.25 10C10.25 9.58578 10.5858 9.25 11 9.25L18 9.25C18.4142 9.25 18.75 9.58578 18.75 10C18.75 10.4142 18.4142 10.75 18 10.75L11 10.75C10.5858 10.75 10.25 10.4142 10.25 10ZM10.25 14C10.25 13.5858 10.5858 13.25 11 13.25L18 13.25C18.4142 13.25 18.75 13.5858 18.75 14C18.75 14.4142 18.4142 14.75 18 14.75L11 14.75C10.5858 14.75 10.25 14.4142 10.25 14ZM5.25 18C5.25 17.5858 5.58579 17.25 6 17.25L18 17.25C18.4142 17.25 18.75 17.5858 18.75 18C18.75 18.4142 18.4142 18.75 18 18.75L6 18.75C5.58579 18.75 5.25 18.4142 5.25 18Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
